import { get } from 'lodash';
import { filterAccommodations } from 'Components/widgets/additional-accommodations/AdditionalAccommodationsUtils';
import {
  CLEAR_ADDITIONAL_ACCOMMODATIONS,
  CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS,
  UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS,
  FETCH_ADDITIONAL_ACCOMMODATIONS,
  TOGGLE_ACCOMMODATIONS_FILTER,
  UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY,
  TOGGLE_EXTRA_FEATURES,
} from 'Store/booking/additional-accommodations/additionalAccommodations.action';
import {
  getFiltersWithMatchedOccurrences,
  toggleFilter,
  getPreselectedFilters,
  updateFilters,
} from 'Store/filters/filtersHelper';
import { createFilters, handleReducedMobilityFilter, unselectCategory } from './filterUtils';
type State = Array<Filter> | null | undefined;
const initialState: State = null;
export function filtersReducer(state: State = initialState, action: Action<any>): State {
  const additionalAccommodations = get(action, 'payload.additionalAccommodations') || [];
  const proposal = get(action, 'payload.selectedProposal') || null;
  // Keep PMR rooms in the dataset so the mobilité réduite filter is always available
  // when API returned at least one PMR room. Display reveal/hide is handled in the UI.
  const filteredAdditionalAccommodations =
    proposal && additionalAccommodations.length
      ? filterAccommodations(proposal, additionalAccommodations)
      : additionalAccommodations;
  const getFiltersWithOccurrences = getFiltersWithMatchedOccurrences(
    filteredAdditionalAccommodations,
  );

  const removeNoMatchedOccurencesConfigurationFilters = (filters) =>
    filters?.filter((filter) => {
      const shouldKeepFilter =
        filter.category !== 'configuration' ||
        (filter.category === 'configuration' && !!filter.matchedOccurrences);
      return shouldKeepFilter;
    });

  switch (action.type) {
    case CLEAR_ADDITIONAL_ACCOMMODATIONS:
    case FETCH_ADDITIONAL_ACCOMMODATIONS:
      return initialState;

    case CREATE_ADDITIONAL_ACCOMMODATIONS_FILTERS: {
      const { product, selectedProposal, shouldPreselectFilters } = action.payload;
      const filters = createFilters(filteredAdditionalAccommodations, product);
      const filtersWithOccurences = getFiltersWithOccurrences(filters);
      const cleanedFilters = removeNoMatchedOccurencesConfigurationFilters(filtersWithOccurences);
      return cleanedFilters && shouldPreselectFilters
        ? getPreselectedFilters(cleanedFilters, selectedProposal)
        : cleanedFilters;
    }

    case UPDATE_ADDITIONAL_ACCOMMODATIONS_FILTERS:
      return updateFilters(filteredAdditionalAccommodations)(state || []);

    case TOGGLE_ACCOMMODATIONS_FILTER:
      const { filter } = action.payload;
      return toggleFilter(filteredAdditionalAccommodations)(state || [], filter);

    case TOGGLE_EXTRA_FEATURES: {
      const { accommodationsSets } = action.payload;
      const reducedMobilityVisibility = get(action, 'payload.reducedMobilityVisibility') || false;
      return handleReducedMobilityFilter(accommodationsSets, reducedMobilityVisibility, state);
    }

    case UNSELECT_ADDITIONAL_ACCOMMODATIONS_FILTER_CATEGORY:
      const { category } = action.payload;
      const updatedFilters = unselectCategory(state || [])(category);
      return getFiltersWithOccurrences(updatedFilters);

    default:
      return state;
  }
}
